import CanvasContent from "./CanvasContent";
import Controls from "./Controls";
import ErrorBanner from "./ErrorBanner";
import { FlowConnectionMirrorProvider } from "./hooks/useFlowConnectionMirror";
import HistoryProvider from "./hooks/useUndoRedo";
import InputVariablesFooter from "./InputVariablesFooter";

interface CanvasProps {
  readonly?: boolean;
}

const Canvas = ({ readonly }: CanvasProps) => (
  <HistoryProvider>
    <div className="relative flex h-full w-full flex-col">
      <ErrorBanner />
      <div className="relative flex-1 overflow-hidden">
        <Controls readonly={!!readonly} />
        <FlowConnectionMirrorProvider>
          <CanvasContent readonly={readonly} />
        </FlowConnectionMirrorProvider>
      </div>
      <InputVariablesFooter readonly={!!readonly} />
    </div>
  </HistoryProvider>
);

export default Canvas;
